// messageCenter/docLinks.js — document links {id} in rendered message texts (tickets, notices): like the overlay info
// texts, unpublished or missing documents turn grey, the others open the document in a new tab (bigplan
// backend/message-center; moved out of messageCenterController.js in step 7b-1 for the second consumer).
import { str } from '../i18n/str.js';
import { resolveDocs } from '../topoEditor/docResolve.js';

/** Resolves the not yet resolved document links in container and marks them; each link is asked once. */
export function decorateDocLinks(container, resolve = resolveDocs) {
    const links = [...container.querySelectorAll('.topo2-doclink[data-doc-id]:not([data-resolved])')];
    if (!links.length) { return; }
    links.forEach((a) => { a.dataset.resolved = '1'; });
    resolve(links.map((a) => a.dataset.docId)).then((map) => {
        for (const a of links) {
            const r = map[a.dataset.docId];
            if (!r) { continue; }
            if (!r.exists || !r.published) {
                a.classList.add('is-unpublished');
                a.title = str('DOC_LINK_UNPUBLISHED');
            } else {
                a.dataset.href = (r.own === false && r.domain ? 'https://' + r.domain : '') + '/?doc=' + encodeURIComponent(a.dataset.docId);
                if (r.own === false) { a.classList.add('is-foreign'); }
            }
        }
    });
}

/** Opens a resolved document link in a new tab; an unpublished or unresolved one does nothing. */
export function openDoc(link) {
    if (link.classList.contains('is-unpublished') || !link.dataset.href) { return; }
    window.open(link.dataset.href, '_blank', 'noopener');
}
